import { useState } from 'react';
import { Button, Card, inputCls } from '../components/ui';
import { useTitle } from '../components/Layout';

const FAQ = [
  ['Jak długo trwa dostawa?', 'Produkty z magazynu wysyłamy w 24 h. Meble na zamówienie powstają 10–14 dni roboczych.'],
  ['Czy mogę zwrócić towar?', 'Tak, masz 30 dni od odbioru. Zgłoszenie zwrotu znajdziesz w zakładce Moje konto.'],
  ['Czy wystawiacie faktury?', 'Tak, wystarczy podać NIP w uwagach do zamówienia.'],
  ['Czy montujecie meble?', 'Montaż biurek podnoszonych jest dostępny w Warszawie za dopłatą 199 zł.'],
];

export function Contact() {
  useTitle('Kontakt');
  const [form, setForm] = useState({ name: '', email: '', topic: 'Pytanie o produkt', message: '' });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [sent, setSent] = useState(false);
  const [open, setOpen] = useState<number | null>(0);

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const err: Record<string, string> = {};
    if (form.name.trim().length < 3) err.name = 'Podaj imię i nazwisko.';
    if (!form.email.includes('@')) err.email = 'Podaj poprawny adres e-mail.';
    if (form.message.trim().length < 10) err.message = 'Opisz sprawę w co najmniej 10 znakach.';
    setErrors(err);
    if (Object.keys(err).length > 0) return;

    fetch('/api/contact', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(form),
    }).catch(() => {});
    setSent(true);
  };

  return (
    <>
      <h1 className="mb-5 text-xl font-semibold text-white">Kontakt</h1>

      <div className="grid gap-5 lg:grid-cols-2">
        <Card className="p-5">
          <h2 className="mb-3 text-base font-semibold text-white">Napisz do nas</h2>
          {sent ? (
            <div className="rounded-lg bg-[#22d3a6]/10 p-4 text-[13px] text-[#7ef0d0]">
              Dziękujemy za wiadomość. Odpowiadamy w ciągu jednego dnia roboczego.
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-3">
              <div>
                <label className="mb-1 block text-xs text-slate-400" htmlFor="c-name">
                  Imię i nazwisko
                </label>
                <input
                  id="c-name"
                  className={inputCls}
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  placeholder="Jan Kowalski"
                />
                {errors.name && <p className="mt-1 text-[11.5px] text-[#ffb0bb]">{errors.name}</p>}
              </div>
              <div>
                <label className="mb-1 block text-xs text-slate-400" htmlFor="c-email">
                  E-mail
                </label>
                <input
                  id="c-email"
                  className={inputCls}
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  placeholder="jan@example.com"
                />
                {errors.email && <p className="mt-1 text-[11.5px] text-[#ffb0bb]">{errors.email}</p>}
              </div>
              <div>
                <label className="mb-1 block text-xs text-slate-400" htmlFor="c-topic">
                  Temat
                </label>
                <select
                  id="c-topic"
                  className={inputCls}
                  value={form.topic}
                  onChange={(e) => setForm({ ...form, topic: e.target.value })}
                >
                  <option>Pytanie o produkt</option>
                  <option>Status zamówienia</option>
                  <option>Zwrot lub reklamacja</option>
                  <option>Współpraca B2B</option>
                </select>
              </div>
              <div>
                <label className="mb-1 block text-xs text-slate-400" htmlFor="c-msg">
                  Wiadomość
                </label>
                <textarea
                  id="c-msg"
                  rows={5}
                  className={inputCls}
                  value={form.message}
                  onChange={(e) => setForm({ ...form, message: e.target.value })}
                  placeholder="W czym możemy pomóc?"
                />
                {errors.message && <p className="mt-1 text-[11.5px] text-[#ffb0bb]">{errors.message}</p>}
              </div>
              <Button type="submit">Wyślij wiadomość</Button>
            </form>
          )}
        </Card>

        <div className="space-y-3">
          <Card className="p-5 text-[13px] text-slate-300">
            <h2 className="mb-2 text-base font-semibold text-white">Obsługa klienta</h2>
            <p>
              {/*
                contact-link = zakres dla triggera Click w GTM (CSS Selector:
                .contact-link, .contact-link *).
                data-contact-method = wartość parametru, czytana Auto-Event
                Variable → Element Attribute. Bez parsowania href w GTM —
                zmiana numeru albo dopisanie ?subject= do maila niczego nie
                zepsuje, bo trigger i tak nie patrzy na href.
              */}
              <a
                href="mailto:sklep@nordform.example"
                className="contact-link text-[#9ec5ff] hover:underline"
                data-contact-method="email"
              >
                sklep@nordform.example
              </a>
            </p>
            <p className="mt-1">
              <a
                href="tel:+48221234567"
                className="contact-link text-[#9ec5ff] hover:underline"
                data-contact-method="phone"
              >
                +48 22 123 45 67
              </a>
            </p>
            <p className="mt-2 text-slate-400">Poniedziałek–piątek, 9:00–17:00</p>
            <p className="mt-3 text-slate-400">
              Nordform sp. z o.o.
              <br />
              ul. Przykładowa 12, 00-001 Warszawa
              <br />
              NIP 000-000-00-00
            </p>
          </Card>

          <Card className="p-5" id="zwroty">
            <h2 className="mb-3 text-base font-semibold text-white">Najczęstsze pytania</h2>
            <div className="space-y-1">
              {FAQ.map(([q, a], i) => (
                <div key={q} className="border-b border-[#26304d] last:border-0">
                  {/*
                    faq-question = zakres triggera. Tym razem, inaczej niż przy
                    linku do sklepu partnerskiego, DOCHODZI atrybut z pytaniem —
                    tu chodzi o rozróżnienie KTÓRE pytanie kliknięto, a samo
                    {{Click Text}} złapałoby razem z treścią znak „+"/„−"
                    z sąsiedniego <span>. data-faq-question={q} zawsze zawiera
                    czysty tekst pytania i aktualizuje się sam, gdy zmienisz
                    treść w tablicy FAQ powyżej.
                  */}
                  <button
                    onClick={() => setOpen(open === i ? null : i)}
                    className="faq-question flex w-full items-center justify-between gap-3 py-2.5 text-left text-[13px] text-slate-200"
                    aria-expanded={open === i}
                    data-faq-question={q}
                  >
                    {q}
                    <span className="text-slate-500">{open === i ? '−' : '+'}</span>
                  </button>
                  {open === i && <p className="pb-3 text-[12.5px] leading-relaxed text-slate-400">{a}</p>}
                </div>
              ))}
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}
